module.exports = "https://static.wmbcdn.com/uniweb/images/f85cc3a7ba3e52468f61b506b597b578.png";